var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M36 8v25c0 7.2-5.8 13-13 13h0c-7.2 0-13-5.8-13-13V11c0-5 4-9 9-9h0c5 0 9 4 9 9v20c0 2.8-2.2 5-5 5h0c-2.8 0-5-2.2-5-5V14",
    strokeLinecap: "square",
    strokeWidth: 2,
    stroke: "#111"
  })));
}

export default SvgAttachment;